<template>
  <div
    :class="'rt-picklist ' + (iconSrc ? 'hasprefixicon' : '')"
    @mouseenter="inputHovering = true"
    @mouseleave="inputHovering = false"
  >
    <rt-icon
      v-show="iconSrc"
      :img-src="iconSrc"
      :class="{ prefixicon: iconSrc }"
    />
    <el-select
      ref="elSelect"
      v-model="selectedValue"
      :disabled="computedDisabled"
      :multiple="multiple"
      :filterable="filterable"
      :size="size"
      :show-max-selected="showMaxSelected"
      :placeholder="computedSelectPlaceholder"
      :collapse-tags="multiple"
      :class="{ 'is-disabled': computedDisabled }"
      clearable
      is-picklist
      :remote="remote"
      :loading="loading"
      :remote-method="remoteMethod"
      :filter-method="filterMethod"
      @change="handleChange"
      @visible-change="visibleChange"
    >
      <template v-if="isGroup">
        <el-option-group
          v-for="(group, index) in dataSource"
          :key="group[nameKey] || index"
          :label="group[nameKey] ? group[nameKey] : ''"
        >
          <el-option
            v-for="(item, optionIndex) in group.options"
            :key="item[valueKey]"
            :label="item[nameKey]"
            :value="item[valueKey]"
            :disabled="item.disabled"
            :multiple="multiple"
          >
            <slot
              :option="item"
              :index="optionIndex"
            >
              <rt-icon
                v-if="item.IconSrc || item.iconSrc || item.iconName"
                :img-src="item.IconSrc || item.iconSrc"
                :name="item.iconName"
                :size="item.iconSize"
                :color="item.iconColor"
                class="rt-picklist-dropdown-item-prefix"
              />
              <div class="rt-picklist-dropdown-item-label-box">
                <span :class="computedItemLabel">
                  {{ item[nameKey] }}
                </span>
                <template v-if="item[optionDescField]">
                  <div
                    v-if="typeof item[optionDescField] === 'string'"
                    class="rt-picklist-dropdown-item-desc"
                  >
                    {{ item[optionDescField] }}
                  </div>
                  <template v-else>
                    <div
                      v-for="(n, i) in item[optionDescField]"
                      :key="n.label + '-' + n.value + '-' + i"
                      class="rt-picklist-dropdown-item-desc"
                    >
                      {{ n.label + ': ' + n.value }}
                    </div>
                  </template>
                </template>
              </div>
            </slot>
          </el-option>
        </el-option-group>
      </template>
      <template v-else>
        <el-option
          v-for="(item, optionIndex) in dataSource"
          :key="item[valueKey]"
          :label="item[nameKey]"
          :value="item[valueKey]"
          :disabled="item.disabled"
          :multiple="multiple"
        >
          <slot
            :option="item"
            :index="optionIndex"
          >
            <div class="rt-picklist-dropdown-item-label-box">
              <div class="rt-picklist-dropdown-item-main">
                <rt-icon
                  v-if="item.IconSrc || item.iconSrc || item.iconName"
                  :img-src="item.IconSrc || item.iconSrc"
                  :name="item.iconName"
                  :size="item.iconSize"
                  :color="item.iconColor"
                  class="rt-picklist-dropdown-item-prefix"
                />
                <span
                  :class="computedItemLabel"
                  v-html="highlightQueryString(item[nameKey])"
                >
                </span>
              </div>
              <template v-if="!hideOptionDesc && item[optionDescField]">
                <div
                  v-if="typeof item[optionDescField] === 'string'"
                  class="rt-picklist-dropdown-item-desc"
                >
                  {{ item[optionDescField] }}
                </div>
                <template v-else>
                  <div
                    v-for="(n, i) in item[optionDescField]"
                    :key="n.label + '-' + n.value + '-' + i"
                    class="rt-picklist-dropdown-item-desc"
                  >
                    {{ n.label + ': ' + n.value }}
                  </div>
                </template>
              </template>
            </div>
          </slot>
        </el-option>
      </template>
    </el-select>
    <rt-icon
      v-show="!computedDisabled && _computedSuffixIcon"
      name="rt-base-dropdown"
      style="pointer-events: none"
    />
    <rt-icon
      v-if="showClose"
      :style="computedClearIconStyle"
      :name="computedIconName"
      class="rt-xpc-picklist-clearicon"
      @click="clear"
    />
  </div>
</template>
<script type="text/javascript">
import RtIcon from '../icon/rtIcon';
import xpcConfig from 'vue-xpc/src/config';
import ElSelect from 'vue-xpc/src/element-ui/packages/select/src/select.vue';
import ElOption from 'vue-xpc/src/element-ui/packages/select/src/option.vue';
import Placeholder from '../form/placeholder.js'
import { isNilOrEmptyString } from 'vue-xpc/src/utils/util';
const DEFAULT_KEYS = {
  value: 'Value',
  name: 'Text'
};
export default {
  name: 'RtPicklist',
  components: {
    RtIcon,
    ElSelect,
    ElOption
  },
  mixins: [Placeholder],
  props: {
    fetch: {
      type: Function,
      default: null,
      required: false
    },
    value: {
      type: [String, Number, Array],
      default: ''
    },
    params: {
      type: Object,
      default: null
    },
    entity: {
      type: String
    },
    attribute: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    alias: {
      type: Object,
      default () {
        return {};
      }
    },
    displayValue: {
      type: Array,
      default () {
        return [];
      }
    },
    filterable: {
      type: Boolean,
      default: false
    },
    // 仅过滤 displayValue 的数据
    onlyFilterDisplayValue: Boolean,
    size: {
      type: String,
      default () {
        return '';
      }
    },
    // 自定义清空按钮图标
    clearIconName: {
      type: String,
      default: undefined
    },
    // 自定义清空按钮位置
    clearIconRight: {
      type: Number,
      default: 0
    },
    // 最多显示多少个已选标签
    showMaxSelected: {
      type: Number,
      default: null
    },
    // 是否显示清空按钮
    clearable: {
      type: Boolean,
      default: true
    },
    // 支持直接传入options数组
    options: {
      type: Array,
      default: null
    },
    // 选项中是否启用描述
    hideOptionDesc: {
      type: Boolean,
      default: false
    },
    // 是否为远程搜索
    remote: {
      type: Boolean,
      default: false
    },
    // 关键字亮高
    highlightKey: {
      type: Boolean,
      default: true
    },
    // 选项数组中的描述字段名称
    optionDescField: {
      type: String,
      default: 'description'
    },
    // 换行模式
    wordBreak: {
      type: String,
      default: 'break-all'
    }
  },
  data () {
    return {
      selectedValue: null,
      dataSource: [],
      loading: false,
      queryString: '',
      inputHovering: false,
      allOptions: []
    };
  },
  inject: {
    elForm: {
      default: ''
    }
  },
  computed: {
    /**
     * 当清空按钮设置偏移量的时候，显示后缀图标
     */
    _computedSuffixIcon () {
      return (
        (this.clearIconRight || xpcConfig.get('clearicon.clearIconRight')) >=
          24 || !this.showClose
      );
    },
    computedIconName () {
      return this.clearIconName || xpcConfig.get('clearicon.clearIconName');
    },
    computedClearIconStyle () {
      let style = {};
      style['marginRight'] =
        this.clearIconRight || xpcConfig.get('clearicon.clearIconRight') + 'px';
      return style;
    },

    computedDisabled () {
      return this.disabled || (this.elForm || {}).disabled;
    },

    valueKey () {
      return this.alias.value || DEFAULT_KEYS.value;
    },
    nameKey () {
      return this.alias.name || DEFAULT_KEYS.name;
    },
    showClose () {
      let selectedValue = this.multiple
        ? this.selectedValue && this.selectedValue.length !== 0
        : this.selectedValue !== null &&
          this.selectedValue !== undefined &&
          this.selectedValue !== '';
      return (
        selectedValue &&
        this.inputHovering &&
        !this.computedDisabled &&
        this.clearable
      );
    },
    iconSrc () {
      if (this.allOptions && this.selectedValue !== null) {
        const item = this.allOptions.find(
          p => p[this.valueKey] === this.selectedValue && !!p.IconSrc
        );
        return item ? item.IconSrc : null;
      } else {
        return null;
      }
    },
    isGroup () {
      return this.dataSource.some(item => item.options);
    },
    computedItemLabel () {
      return `rt-picklist-dropdown-item-label rt-xpc-${this.wordBreak}`
    }
  },
  watch: {
    value: {
      handler (newVal, oldVal) {
        if (this.multiple && (newVal === '' || newVal === null || newVal === undefined)) {
          this.selectedValue = [];
        } else {
          this.selectedValue = newVal;
        }
      },
      immediate: true,
      deep: true
    },
    displayValue (newVal, oldVal) {
      this.setOptions();
    },
    attribute (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.bindPicklist();
      }
    },
    options (val) {
      this.dataSource = val;
      this._interimDataSource = this.dataSource;
      this.allOptions = val;
    }
  },
  mounted () {
    this.bindPicklist();
  },
  methods: {
    /**
     * 远程搜索方法
     */
    remoteMethod (query) {
      if (query !== '') {
        this.queryString = query;

        const callback = () => {
          let list = this.allOptions;
          // 如果仅仅过滤 displayValue 的数据，
          // 则需要先执行一下setOptions，重新计算一下 dataSource，防止dataSource被覆盖
          if (this.onlyFilterDisplayValue) {
            list = this._interimDataSource;
          }
          this.dataSource = list.filter(item => {
            const name = item[this.nameKey].toString();
            return name.indexOf(this.queryString) > -1;
          });
        }

        this.bindPicklist(query, callback);
      } else {
        this.queryString = ''
        this.bindPicklist();
      }
    },
    filterMethod (query) {
      if (query !== '') {
        this.queryString = query;
        let list = this.allOptions;
        // 如果仅仅过滤 displayValue 的数据，
        // 则需要先执行一下setOptions，重新计算一下 dataSource，防止dataSource被覆盖
        if (this.onlyFilterDisplayValue) {
          list = this._interimDataSource;
        }
        this.dataSource = list.filter(item => {
          const name = item[this.nameKey].toString();
          return name.indexOf(this.queryString) > -1;
        });
      } else {
        this.queryString = '';
        this.setOptions();
      }
    },
    /**
     * @param {String} str
     * 关键字高亮
     */
    highlightQueryString (str) {
      str = (str === null || str === undefined) ? '' : str;
      str = str.toString();
      if (!this.highlightKey) {
        return str;
      } else {
        let index = str.indexOf(this.queryString);
        let queryStringKey = str.slice(index, index + this.queryString.length);
        return str.replace(
          queryStringKey,
          `<span style="color:${this.SCSS_VARIABLES.COLOR_WARNING}">${queryStringKey}</span>`
        );
      }
    },
    bindPicklist (query, callback) {
      if (this.options) {
        this.dataSource = this.options;
        this._interimDataSource = this.dataSource;
        this.allOptions = this.options;
        return;
      }
      if (this.fetch) {
        this.fetch(query)
          .then(res => {
            this.dataSource = res;
            this._interimDataSource = this.dataSource;
            this.allOptions = res;
            this.setOptions();

            if (callback && typeof callback === 'function') {
              callback();
            }
          })
          .catch(error => {
            rt.showErrorToast(error.message);
          });
      } else {
        let { params, entity, attribute } = this;
        params = Object.assign({}, params, { entity, attribute });
        this.$picklist
          .getPicklistData(params)
          .then(res => {
            this.allOptions = res;
            this.setOptions();

            if (callback && typeof callback === 'function') {
              callback();
            }
          })
          .catch(error => {
            rt.showErrorToast(error.message);
          });
      }
      if (this.value || this.value === 0) {
        this.selectedValue = this.value;
      }
    },
    setOptions () {
      if (this.allOptions.length === 0) {
        this.dataSource = [];
        this._interimDataSource = this.dataSource;
        return;
      }
      var _options = this.allOptions;
      if (this.displayValue != null && this.displayValue.length > 0) {
        _options = this.allOptions.filter(
          p => this.displayValue.indexOf(p[this.valueKey]) >= 0
        );
        // 赋值之前判断是否存在选项集中
        if (!this.multiple) {
          if (!isNilOrEmptyString(this.selectedValue)) {
            let selectedValues = _options.filter(
              p => p[this.valueKey] === this.selectedValue
            );
            if (selectedValues == null || selectedValues.length === 0) {
              this.$emit('input', null);
              this.$emit('change', null);
            }
          }
        } else {
          if (this.selectedValue && this.selectedValue.length > 0) {
            let selectedValues = _options.filter(p =>
              this.selectedValue.find(e => p[this.valueKey] === e)
            );
            this.selectedValue = selectedValues.map(e => {
              return e[this.valueKey];
            });
            if (selectedValues == null || selectedValues.length === 0) {
              this.$emit('input', []);
              this.$emit('change', []);
            }
          }
        }
      }
      this.dataSource = _options;
      this._interimDataSource = this.dataSource;
    },
    handleChange (val) {
      // 单选选完后，清空子组件的【原生input】 的value值
      if (this.$refs.elSelect.radioValue) {
        this.$refs.elSelect.radioValue = ''
      }
      let selected = this.dataSource.find(item => {
        return item[this.valueKey] === val;
      });
      this.$emit('input', val);

      this.$emit('change', val, selected);
    },
    // 下拉框出现/隐藏时触发/ 出现则为 true，隐藏则为 false
    visibleChange (val) {
      if (!val) {
        // 单选选完后，清空子组件中【el-input】 的value值
        if (this.$refs.elSelect.selectedLabel) {
          this.$refs.elSelect.selectedLabel = ''
        }
        // 单选选完后，清空当前和子组件中【原生input】远程搜索的参数
        if (this.queryString) {
          this.queryString = ''
        }
      }
    },
    clear () {
      this.handleChange(this.multiple ? [] : null);
      // 清空关键字高亮
      this.queryString = '';
      this.$refs.elSelect.selectedLabel = '';
      // 重新渲染数组
      // this.bindPicklist();
      this.setOptions();
    },
    selectOption () {
      this.$refs.elSelect.selectOption();
    }
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?3883aeb2